var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLockAndShield = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    viewBox: "0 0 642.73 815.26",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "icons"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M321.37,0C107.72,0,0,113.98,0,113.98v229.29c0,388.86,321.37,471.99,321.37,471.99,0,0,321.37-83.14,321.37-471.99V113.98S535.01,0,321.37,0Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M452.43,283.23H190.3c-14.51,0-26.28,11.77-26.28,26.28v206.06c0,14.51,11.77,26.28,26.28,26.28h262.13c14.51,0,26.28-11.77,26.28-26.28v-206.06c0-14.51-11.77-26.28-26.28-26.28ZM342.09,404.7v57.25c0,11.44-9.28,20.72-20.72,20.72s-20.72-9.28-20.72-20.72v-57.25c-8.42-6.31-13.87-16.37-13.87-27.7,0-19.11,15.49-34.6,34.6-34.6s34.6,15.49,34.6,34.6c0,11.33-5.45,21.39-13.87,27.7Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.4,283.23v-24.95c0-37.47,30.49-67.96,67.96-67.96s67.96,30.49,67.96,67.96v24.95h40.17v-24.95c0-59.72-48.41-108.13-108.13-108.13h0c-59.72,0-108.13,48.41-108.13,108.13v24.95h40.17Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLockAndShield, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/lockAndShield.7feab3b8.svg";
export { ForwardRef as ReactComponent };